import { useId } from 'react';
import { timeZoneIndicatorText, timeZoneOptions, type TimeZoneChoice } from './timeZone';

/** The always-visible statement of which zone event times are shown in. Also printed with the statement. */
export function TimeZoneIndicator({ choice, className }: { choice: TimeZoneChoice; className?: string }) {
  return <p className={className ?? 'payslips__tz-indicator'} data-testid="time-zone-indicator">{timeZoneIndicatorText(choice)}</p>;
}

/** The small selector: browser zone (default), Pacific, Mountain, Central, Eastern, Alaska, Hawaii, UTC. */
export function TimeZoneSelect({ choice, onChange }: { choice: TimeZoneChoice; onChange: (choice: TimeZoneChoice) => void }) {
  const id = useId();
  return (
    <div className="payslips__tz-select no-print">
      <label htmlFor={id}>Time zone</label>
      <select id={id} value={choice} onChange={(e) => onChange(e.target.value as TimeZoneChoice)}>
        {timeZoneOptions().map((option) => <option key={option.value} value={option.value}>{option.label}</option>)}
      </select>
    </div>
  );
}
